import * as React from "react";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

import { DataGrid, GridColDef, GridValueGetterParams } from "@mui/x-data-grid";

/* TOOLBAR */
import SearchIcon from "@mui/icons-material/Search";
import MailIcon from "@mui/icons-material/Mail";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";

import DadosBasicosTopo from "./topo";

import Parceiro from "../../components/classes/Parceiro";
import CentroDistribuicao from "../../components/classes/CentroDistribuicao";
import UnidadeArmazenamento from "../../components/classes/UnidadeArmazenamento";

import ParceiroDataset from "../../components/data/parceiroDataset";
import CentroDistribuicaoDataset from "../../components/data/CentroDataset";
import UnidadeArmazenamentoDataset from "../../components/data/UnidadeArmazenamentoDataSet";
import { useTranslation } from "react-i18next";

interface DataParceiro {
  id: Number;
  apelido: String;
  nome: String;
  contato: String;
  enderecoExterior: boolean;
  endereco: String;
  enderecoComplemento: String;
  bairro: String;
  cidade: String;
  uf: String;
  cep: String;
  pais: String;
  email: String;
  telefone: String;
  telefoneContato: String;
  site: String;
  codigoFornecedorSAP: Number;
  codigoClienteSAP: Number;
  codigoCentroEspelho: Number;
  criadoEm: String;
}

interface DataCentro {
  id: Number;
  centro: String;
  nome: String;
  endereco: String;
  pais: String;
  estado: String;
  local: String;
  criadoEm: String;
}

interface DataUnidadeArmazenamento {
  id: number;
  sigla: string;
  idSKU: number;
  descricao: string;
  idioma: string;
  unidadeBasica: String;
  tipoMaterial: string;
  descricaoTipoMaterial: string;
  criadoEm: String;
}

function createDataParceiro(
  id: Number,
  apelido: String,
  nome: String,
  contato: String,
  enderecoExterior: boolean,
  endereco: String,
  enderecoComplemento: String,
  bairro: String,
  cidade: String,
  uf: String,
  cep: String,
  pais: String,
  email: String,
  telefone: String,
  telefoneContato: String,
  site: String,
  codigoFornecedorSAP: Number,
  codigoClienteSAP: Number,
  codigoCentroEspelho: Number,
  criadoEm: String
): DataParceiro {
  return {
    id,
    apelido,
    nome,
    contato,
    enderecoExterior,
    endereco,
    enderecoComplemento,
    bairro,
    cidade,
    uf,
    cep,
    pais,
    email,
    telefone,
    telefoneContato,
    site,
    codigoFornecedorSAP,
    codigoClienteSAP,
    codigoCentroEspelho,
    criadoEm,
  };
}

function createDataCentro(
  id: Number,
  centro: String,
  nome: String,
  endereco: String,
  pais: String,
  estado: String,
  local: String,
  criadoEm: String
): DataCentro {
  return {
    id,
    centro,
    nome,
    endereco,
    pais,
    estado,
    local,
    criadoEm,
  };
}

function createDataUnidadeArmazenamento(
  id: number,
  sigla: string,
  idSKU: number,
  descricao: string,
  idioma: string,
  unidadeBasica: String,
  tipoMaterial: string,
  descricaoTipoMaterial: string,
  criadoEm: String
): DataUnidadeArmazenamento {
  return {
    id,
    sigla,
    idSKU,
    descricao,
    idioma,
    unidadeBasica,
    tipoMaterial,
    descricaoTipoMaterial,
    criadoEm,
  };
}

function formataData(value: Date): String {
  let frmDate: String = "";
  frmDate =
    String(value).substring(8, 10) +
    "/" +
    String(value).substring(5, 7) +
    "/" +
    String(value).substring(0, 4);
  return frmDate;
}

export default function DadosBasicosDetalhe() {
  const { t } = useTranslation();

  const [tab, setTab] = React.useState("Parceiro");
  const [pageSize, setPageSize] = React.useState(5);
  const [rowsParceiro, setRowsParceiros] = React.useState<DataParceiro[]>([]);
  const [rowsCentro, setRowsCentro] = React.useState<DataCentro[]>([]);
  const [rowsSKU, setRowsSKU] = React.useState<DataUnidadeArmazenamento[]>([]);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setTab(newValue);
  };

  const columnsParceiro: GridColDef[] = [
    /* PARCEIRO */
    { field: "id", headerName: "#", width: 45 },
    {
      field: "codigoFornecedorSAP",
      headerName: t("pages.basicData.text.sapSupplierCode"),
      width: 200,
      editable: false,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "apelido",
      headerName: t("common.group"),
      width: 120,
      editable: false,
      headerAlign: "center",
      align: "left",
    },
    {
      field: "nome",
      headerName: t("common.name"),
      width: 300,
      editable: false,
      headerAlign: "center",
      align: "left",
    },
    {
      field: "contato",
      headerName: t("common.contact"),
      type: "number",
      width: 200,
      editable: false,
      headerAlign: "center",
      align: "left",
    },
    {
      field: "endereco",
      headerName: t("common.address"),
      width: 250,
      editable: false,
      headerAlign: "center",
      align: "left",
    },
    {
      field: "enderecoComplemento",
      headerName: t("common.complement"),
      width: 250,
      editable: false,
      headerAlign: "center",
      align: "left",
    },
    {
      field: "bairro",
      headerName: t("common.neighborhood"),
      width: 250,
      editable: false,
      headerAlign: "center",
      align: "left",
    },
    {
      field: "cidade",
      headerName: t("common.city"),
      width: 250,
      editable: false,
      headerAlign: "center",
      align: "left",
    },
    {
      field: "uf",
      headerName: t("common.stateAbbreviation"),
      width: 100,
      editable: false,
      headerAlign: "center",
      align: "left",
    },
    {
      field: "cep",
      headerName: t("common.postalCode"),
      width: 100,
      editable: false,
      headerAlign: "center",
      align: "left",
    },
    {
      field: "pais",
      headerName: t("common.country"),
      width: 150,
      editable: false,
      headerAlign: "center",
      align: "left",
    },
    {
      field: "email",
      headerName: t("common.email"),
      width: 200,
      editable: false,
      headerAlign: "center",
      align: "left",
    },
    {
      field: "telefone",
      headerName: t("common.phone"),
      width: 200,
      editable: false,
      headerAlign: "center",
      align: "left",
    },
    {
      field: "telefoneContato",
      headerName: t("common.contactPhone"),
      width: 200,
      editable: false,
      headerAlign: "center",
      align: "left",
    },
    {
      field: "site",
      headerName: t("common.website"),
      width: 200,
      editable: false,
      headerAlign: "center",
      align: "left",
    },
    {
      field: "codigoClienteSAP",
      headerName: t("pages.basicData.text.sapClientCode"),
      width: 150,
      editable: true,
      align: "left",
    },
    {
      field: "criadoEm",
      headerName: t("common.createdAt"),
      width: 350,
      editable: false,
      headerAlign: "center",
      align: "center",
    },
  ];

  const columnsSKU: GridColDef[] = [
    /* SKU */
    {
      field: "id",
      headerName: t("common.id"),
      width: 100,
      editable: false,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "sigla",
      headerName: t("common.acronym"),
      width: 200,
      editable: false,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "idSKU",
      headerName: t("common.sku"),
      width: 150,
      editable: false,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "descricao",
      headerName: t("common.description"),
      width: 400,
      editable: false,
      headerAlign: "center",
      align: "left",
    },
    {
      field: "idioma",
      headerName: t("common.language"),
      width: 100,
      editable: false,
      headerAlign: "center",
      align: "left",
    },
    {
      field: "unidadeBasica",
      headerName: t("common.basicUnit"),
      width: 150,
      editable: false,
      headerAlign: "center",
      align: "left",
    },
    {
      field: "tipoMaterial",
      headerName: t("common.materialType"),
      width: 120,
      editable: false,
      headerAlign: "center",
      align: "left",
    },
    {
      field: "descricaoTipoMaterial",
      headerName: t("common.materialTypeDescription"),
      width: 350,
      editable: false,
      headerAlign: "center",
      align: "left",
    },
    {
      field: "criadoEm",
      headerName: t("common.createdAt"),
      width: 350,
      editable: false,
      headerAlign: "center",
      align: "center",
    },
  ];

  const columnsCentro: GridColDef[] = [
    /* Centro de Distribuicao */
    { field: "id", headerName: t("common.id"), width: 150, editable: false },
    {
      field: "centro",
      headerName: t("common.center"),
      width: 150,
      editable: false,
    },
    {
      field: "nome",
      headerName: t("common.name"),
      width: 150,
      editable: false,
    },
    {
      field: "endereco",
      headerName: t("common.address"),
      width: 150,
      editable: false,
    },
    {
      field: "pais",
      headerName: t("common.country"),
      width: 150,
      editable: false,
    },
    {
      field: "estado",
      headerName: t("common.state"),
      width: 150,
      editable: false,
    },
    {
      field: "local",
      headerName: t("common.local"),
      width: 150,
      editable: false,
    },
    {
      field: "criadoEm",
      headerName: t("common.createdAt"),
      width: 350,
      editable: false,
      headerAlign: "center",
      align: "center",
    },
  ];

  React.useEffect(() => {
    if (tab === "Parceiro") {
      new ParceiroDataset().ListarAtivos().then((result) => {
        setRowsParceiros((): DataParceiro[] =>
          result.map((_parceiro: Parceiro) => {
            return createDataParceiro(
              _parceiro.id,
              _parceiro.apelido,
              _parceiro.nome,
              _parceiro.contato,
              _parceiro.enderecoExterior,
              _parceiro.endereco,
              _parceiro.enderecoComplemento,
              _parceiro.bairro,
              _parceiro.cidade,
              _parceiro.uf,
              _parceiro.cep,
              _parceiro.pais,
              _parceiro.email,
              _parceiro.telefone,
              _parceiro.telefoneContato,
              _parceiro.site,
              _parceiro.codigoFornecedorSAP,
              _parceiro.codigoClienteSAP,
              _parceiro.codigoCentroEspelho,
              formataData(_parceiro.criadoEm)
            );
          })
        );
      });
    } else {
      if (tab === "Sku") {
        new UnidadeArmazenamentoDataset().ListarAtivos().then((result) => {
          setRowsSKU((): DataUnidadeArmazenamento[] =>
            result.map((_unidadeArmazenamento: UnidadeArmazenamento) => {
              return createDataUnidadeArmazenamento(
                _unidadeArmazenamento.id,
                _unidadeArmazenamento.sigla,
                _unidadeArmazenamento.idSKU,
                _unidadeArmazenamento.descricao,
                _unidadeArmazenamento.idioma,
                _unidadeArmazenamento.unidadeBasica,
                _unidadeArmazenamento.tipoMaterial,
                _unidadeArmazenamento.descricaoTipoMaterial,
                formataData(_unidadeArmazenamento.criadoEm)
              );
            })
          );
        });
      } else {
        if (tab === "Centro") {
          new CentroDistribuicaoDataset().ListarAtivos().then((result) => {
            setRowsCentro((): DataCentro[] =>
              result.map((_centro: CentroDistribuicao) => {
                return createDataCentro(
                  _centro.id,
                  _centro.centro,
                  _centro.nome,
                  _centro.endereco,
                  _centro.pais,
                  _centro.estado,
                  _centro.local,
                  formataData(_centro.criadoEm)
                );
              })
            );
          });
        }
      }
    }
  }, [tab]);

  return (
    <div className="container">
      <React.Fragment>
        <DadosBasicosTopo />
        {/*     <div className="containerToolbar">
                    <Tooltip title="Faz busca por campos pré-selecionados!" >
                        <IconButton aria-label="Buscar" >
                            <SearchIcon />
                        </IconButton>
                    </Tooltip>
                    <React.Fragment>
                        <Tooltip title="Notificar!" >
                            <IconButton> <ChatBubbleIcon /> </IconButton>
                        </Tooltip>
                        <Tooltip title="Mandar mensagem !" >
                            <IconButton> <MailIcon /> </IconButton>
                        </Tooltip>
                    </React.Fragment>
    </div> */}
        <div className="insiderContainer">
          <Box sx={{ width: "100%" }}>
            <Tabs
              value={tab}
              onChange={handleChange}
              textColor="secondary"
              indicatorColor="secondary"
              aria-label="secondary tabs example"
            >
              <Tab
                value="Parceiro"
                label={t("pages.basicData.text.partners")}
              />
              <Tab value="Sku" label={t("pages.basicData.text.sku")} />
              <Tab
                value="Centro"
                label={t("pages.basicData.text.distributionCenter")}
              />
            </Tabs>
          </Box>
          <div
            style={{
              width: "100%",
              height: "50vh",
              backgroundColor: "#FFFAFA",
              scrollBehavior: "auto",
            }}
          >
            <DataGrid
              rows={
                tab === "Parceiro"
                  ? rowsParceiro
                  : tab === "Sku"
                  ? rowsSKU
                  : rowsCentro
              }
              columns={
                tab === "Parceiro"
                  ? columnsParceiro
                  : tab === "Sku"
                  ? columnsSKU
                  : columnsCentro
              }
              rowsPerPageOptions={[50, 100, 250, 500]}
              checkboxSelection
              disableSelectionOnClick
            />
          </div>
        </div>
      </React.Fragment>
    </div>
  );
}
